























import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/cg_user_types";
@Component({
  components: {}
})
export default class ExclusivePakage extends Vue {
  @Getter(types.GETTER_VIP_VALID_COUNT)
  private vip_valid_count: any;

  private goToPakage() {
    this.$router.push({
      name: "VipDiscount",
      query: {
        routerTransition: "up"
      }
    });
  }
}
